import { memo } from 'react'
import PlatformModal from '@/components/PlatformModal/PlatformModal'
import { usePlatformModal } from '@/store/platformModalContext'

const GlobalPlatformModal = () => {
  const { isPlatformModalVisible, hidePlatformModal, params } = usePlatformModal()

  // 只有在需要显示时才渲染 PlatformModal 组件
  if (!isPlatformModalVisible) {
    return null
  }

  return <PlatformModal visible={isPlatformModalVisible} onCancel={hidePlatformModal} {...params} />
}

export default memo(GlobalPlatformModal)
